import { Flex } from 'onefaceui-react-components';
import styled from 'styled-components';

const StopStatusColors = {
  PENDING: 'var(--pending-stop)',
  DELIVERED: 'var(--delivered-stop)',
  PARTIALLY_DELIVERED: 'var(--partially_delivered)',
  REDELIVERED: 'var(--redelivered-stop)',
  UNDELIVERED: 'var(--undelivered-stop)',
  CANCELED: 'var(--canceled-stop)',
  IN_PROGRESS: 'var(--in_progress)'
};

const iconBackgrounds = {
  pending: 'var(--icon-pending-stop)',
  delivered: 'var(--icon-delivered-stop)',
  partially_delivered: 'var(--icon-partially_delivered-stop)',
  redelivered: 'var(--icon-redelivered-stop)',
  undelivered: 'var(--icon-undelivered-stop)',
  canceled: 'var(--icon-canceled-stop)',
  in_progress: 'var(--icon-in_service-stop)'
};

const iconStopStatusListItem = {
  pending: 'var(--icon-filled-pending-stop)',
  delivered: 'var(--icon-filled-delivered-stop)',
  partially_delivered: 'var(--icon-filled-partially_delivered-stop)',
  redelivered: 'var(--icon-filled-redelivered-stop)',
  undelivered: 'var(--icon-filled-undelivered-stop)',
  canceled: 'var(--icon-filled-canceled-stop)',
  in_progress: 'var(--icon-filled-in_service-stop)'
};

export const Container = styled(Flex)`
  flex: 1;
  height: 100%;

  .stops-list {
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
  }

  .stop-status-sequence {
    color: var(--grey-400);
  }

  .oneface-date-picker button {
    padding-left: 0px !important;
    padding-right: 0px !important;
    height: auto !important;
  }
`;

export const Header = styled(Flex)`
  padding: 8px 14px;
  box-shadow: 0px 2px 6px #00000033;

  .date-filter {
    input {
      height: 30px !important;
      width: 100% !important;
      padding: 0 5px !important;
      padding-right: 28px !important;
    }
  }
`;

export const SearchInput = styled(Flex)`
  position: relative;

  .oneface-input {
    padding-right: 26px;
  }

  img {
    width: 34px;
    position: absolute;
    top: 4px;
    right: 2px;
  }
`;

export const Filters = styled(Flex)`
  margin-top: 4px;

  img {
    width: 26px;
  }
`;

export const ToggleButton = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  background-color: #fff;
  color: var(--grey-900);
  transition: all 0.2s;
  height: 22px !important;
  width: 22px !important;
  border: 1px solid var(--grey-300);
  border-radius: 100% !important;
  font-weight: 600 !important;
  padding: 4px !important;

  &:hover {
    background-color: var(--grey-200);
  }

  &::after {
    content: '';
    width: 22px;
    height: 22px;
    border-radius: 100%;
    background-size: 30px !important;
  }

  &.active {
    background: var(--grey-200);
    border-radius: 100%;
  }

  &.pending::after {
    background: ${iconBackgrounds.pending};
  }

  &.delivered::after {
    background: ${iconBackgrounds.delivered};
  }

  &.partially_delivered::after {
    background: ${iconBackgrounds.partially_delivered};
  }

  &.redelivered::after {
    background: ${iconBackgrounds.redelivered};
  }

  &.undelivered::after {
    background: ${iconBackgrounds.undelivered};
  }

  &.canceled::after {
    background: ${iconBackgrounds.canceled};
  }

  &.in_progress::after {
    background: ${iconBackgrounds.in_progress};
  }
`;

const generateStopStatusStyles = (status, color) => `
  .${status} .stop-status-date {
    color: ${color};
  }
  
  .${status} .icon-content {
    .content {
      font-weight: 700;
      color: white;
      width: 15px;
      height: 15px;
      padding: 10px;
      border-radius: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 18px;
    }
  }
  .status.${status} {
    background-color: ${color};
  }

   ${
     status !== 'pending'
       ? `
      .${status} .icon-content {
          .content {
            background: ${iconStopStatusListItem[status]};
          }
        }
      `
       : `
      .${status} .icon-content {
        .iconNextStop {
          width: 45px;
          height: 45px;
        }
        .content {
          position: absolute;
          background: ${StopStatusColors.PENDING};
        }
      }
  `
   }
`;

export const Stop = styled.li`
  display: flex;
  border-bottom: solid var(--grey-300) 1px;

  .address-text {
    color: var(--grey-600);
  }

  .phone-icon {
    width: 12px;
    height: 12px;
    background-size: contain;
    &.phone1 {
      background: var(--icon-phone1);
    }
    &.phone2 {
      background: var(--icon-phone2);
    }
  }

  .size-item i {
    font-size: 18px;
  }

  .status {
    height: 32px;
    border-radius: 0 2px 2px 0;
    margin-top: 15px;
    width: 10px;
  }

  .stop-status {
    width: 20%;
    display: flex;
    margin: 5px 0;
    p {
      display: flex;
      justify-content: center;
      font-weight: 700;
    }
    .icon-content {
      width: 100%;
      height: 40px;
      align-items: center;
      justify-content: center;
      display: flex;
      position: relative;
      margin: 5px 0;
    }
  }

  ${generateStopStatusStyles('pending', StopStatusColors.PENDING)}
  ${generateStopStatusStyles('delivered', StopStatusColors.DELIVERED)}
  ${generateStopStatusStyles(
    'partially_delivered',
    StopStatusColors.PARTIALLY_DELIVERED
  )}
  ${generateStopStatusStyles('redelivered', StopStatusColors.REDELIVERED)}
  ${generateStopStatusStyles('undelivered', StopStatusColors.UNDELIVERED)}
  ${generateStopStatusStyles('canceled', StopStatusColors.CANCELED)}
  ${generateStopStatusStyles('in_progress', StopStatusColors.IN_PROGRESS)}

  .generic-modal-portal {
    height: 0 !important;
  }

  .stop-content {
    padding: 8px;
    flex: 100%;

    .twStatus {
      font-weight: bold;
      font-size: 14px;

      &.status-within {
        color: #2c882d;
      }
      &.status-outside {
        color: #c23400;
      }
    }
    .icon-outside-time-window {
      width: 14px;
      height: 14px;
    }
  }

  .stop-content {
    .oneface-icon-button {
      height: auto !important;
      align-self: flex-start;
    }
  }

  .icon-delivery {
    width: 18px;
    height: 18px;
  }

  .route-details-line-items {
    width: 1050px;
    overflow: unset;
  }
`;
